import React, { useState } from "react";

// App
import EmailConfigBrandItem from "./EmailConfigBrandItem";

// Modules & UI
import { useSelector } from "react-redux";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import { Box, Stack, Button } from "@mui/material"; // {Stack}

export default function EmailConfigTemplateItem(props) {
  const template = props.templateIdentityCode;

  // redux
  const user = useSelector((state) => state.authReducer).user;

  return (
    <div
      className={
        props.templateIdentityCode === props.selectedTemplate
          ? "selected-email-config-template-item"
          : "email-config-template-item"
      }
      onClick={() => {
        props.addSelectedTemplateItem(template);
      }}
    >
      <Box sx={{ padding: 2 }}>
        <div className="email-config-template-item-container">
          <div className="email-config-template-item-image">
            <img alt="plus" src="./assets/plus_button.png" />
          </div>
          <div className="email-config-template-item-info">
            <div className="email-config-template-item-title">
              {props.itemIndex + 1}. {props.templateName}
            </div>
            <div className="email-config-template-item-description">{props.templateDescription}</div>
          </div>
        </div>

        {props.selectedTemplate && (
          <Accordion expanded={true} onChange={() => {}} className="accordion">
            <AccordionDetails>
              <div
                id="email-config-brands-view-content"
                className={`email-config-templates-view-content block-display-visible`}
              >
                <div className="email-config-brand-items-wrapper">
                  <div className="available-email-config-brands-title">
                    <span>Select Brand</span>
                  </div>
                  <div id="email-config-brand-items">
                    {props.brands.map((brand, index) => {
                      return (
                        <EmailConfigBrandItem
                          key={`key-${index}`}
                          brandIdentityCode={brand.identity_code}
                          brandName={brand.name}
                          mainImageUrl={brand.main_image_url}
                          selectedBrand={props.selectedBrand}
                          addSelectedBrandItem={(item) => {
                            props.setSelectedBrand(item);
                          }}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        )}

        {props.selectedTemplate && props.selectedBrand && (
          <Box className="action-group">
            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button
                variant="outlined"
                onClick={() => {
                  const subdomain = props.system.subdomain;
                  const template = props.selectedTemplate;
                  const brand = props.selectedBrand;
                  const uid = user?.current_user.uid;
                  let presentation_ids = "";
                  let news_ids = "";
                  let document_ids = "";
                  let webform_ids = "";
                  let event_ids = "";

                  let accessToken = "";

                  if (props?.config?.sample_presentation_ids) {
                    presentation_ids = `&presentation_ids=${props.config.sample_presentation_ids}`;
                  }

                  if (props?.config?.sample_news_ids) {
                    news_ids = `&news_ids=${props.config.sample_news_ids}`;
                  }

                  if (props?.config?.sample_document_ids) {
                    document_ids = `&document_ids=${props.config.sample_document_ids}`;
                  }

                  if (props?.config?.sample_webform_ids) {
                    webform_ids = `&webform_ids=${props.config.sample_webform_ids}`;
                  }

                  if (props?.config?.sample_event_ids) {
                    event_ids = `&event_ids=${props.config.sample_event_ids}`;
                  }

                  if (props?.token?.access_token) {
                    accessToken = `&token=${props.token.access_token}`;
                  }

                  const url = `https://addinconfig.companyapp.net/preview.html?subdomain=${subdomain}&template=${template}&brand=${brand}&uid=${uid}${presentation_ids}${news_ids}${document_ids}${webform_ids}${event_ids}${accessToken}`;

                  window.open(url, "_blank");
                }}
              >
                Preview
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  props.onNext();
                }}
              >
                Next
              </Button>
            </Stack>
          </Box>
        )}
      </Box>
    </div>
  );
}
